import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import BudgetExpensesModal from "./modals/budgetExpensesModal";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { deleteBudgetExpense, fetchAllBudgetExpenses } from "../../core/data/redux/payroll/Accounting/budgetExpenses/budgetExpensesActions";
import { message } from "antd";
import PageHeader from "../../core/common/commonComponents/PageHeader";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../core/common/GlobalFunctions/exportTableData";
import StatusFilterHeader from "../../core/common/commonComponents/StatusFilterHeader";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { formatDate } from "../../core/utils/FormatData";
import { decryptData } from "../../core/utils/encryptUtils";

const BudgetExpenses = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { expenses } = useSelector((state: any) => state.accounting.budgetExpenses);

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");


  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
  };

  const handleDeleteBudget = async (id: number) => {
    try {
      const result = await dispatch(deleteBudgetExpense(id));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Budget Expense deleted successfully");
        setTableKey((prevKey) => prevKey + 1);
        setIsDeleteModalVisible(false);
      } else {
        message.error((result.payload as { error: string })?.error);
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  };
  useEffect(() => {
    dispatch(fetchAllBudgetExpenses());
  }, [dispatch]);

  const filtereddata = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { status: selectedStatus }
        : {};
    return filterData(expenses, filters, "createdAt", "createdAt", selectedSort);
  }, [expenses, selectedStatus, selectedSort]);

  const ExportData = filtereddata.map((item: any) => ({
    // budget_expense_id: item.budget_expense_id || "N/A",
    expenseName: item.expenseName || "N/A",
    amount: item.amount ?? 0,
    expenseDate: item.expenseDate ? new Date(item.expenseDate).toLocaleDateString("en-IN") : "N/A",
    status: item.status || "Inactive",
    // createdBy: item.createdBy || "N/A",
    // modifiedBy: item.modifiedBy || "N/A",
    createdAt: item.createdAt ? new Date(item.createdAt).toLocaleDateString("en-IN") : "N/A",
    modifiedAt: item.modifiedAt ? new Date(item.modifiedAt).toLocaleDateString("en-IN") : "N/A",
    categoryName: item.categoryName || "N/A",
    subCategoryName: item.subCategoryName || "N/A",
  }));


  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, expenses]);

  const columns = [
    {
      title: "Expense Name",
      dataIndex: "expenseName",
      sorter: (a: any, b: any) => a.expenseName.length - b.expenseName.length,
    },
    {
      title: "Category Name",
      dataIndex: "categoryName",
      sorter: (a: any, b: any) => a.categoryName.length - b.categoryName.length,
    },
    {
      title: "Sub Category Name",
      dataIndex: "subCategoryName",
      sorter: (a: any, b: any) =>
        a.subCategoryName.length - b.subCategoryName.length,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a: any, b: any) => a.amount.length - b.amount.length,
    },
    {
      title: "Expense Date",
      dataIndex: "expenseDate",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) => a.expenseDate.length - b.expenseDate.length,
    },
    {
      title: "File",
      dataIndex: "filePath",
      render: (filePath: string) => {
        if (!filePath) return "No File";

        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
        const extension = filePath.split('.').pop()?.toLowerCase();

        const isImage = imageExtensions.includes(extension || "");

        return (
          <a
            href={filePath}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-outline-primary"
            title={isImage ? "View Image" : "Download File"}
          >
            <i className={`ti ${isImage ? 'ti-eye' : 'ti-download'}`} />
          </a>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div>
          <div className="action-icon d-inline-flex">
            {/* Edit Button */}
            {canEdit && (
              <button
                className="me-2"
                onClick={() => {
                  showModal("edit");
                  setSelectedRowData(record);
                }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Edit"
              >
                <i className="ti ti-edit" />
              </button>
            )}

            {/* Delete Button */}
            {canDelete && (
              <button
                className={`me-2 ${record.status === "inactive" ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={record.status === "inactive"}
                onClick={() => {
                  if (record.status === "inactive") return;
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={record.status === "inactive" ? "Cannot delete inactive record" : "Delete"}
              >
                <i className="ti ti-trash" />
              </button>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <PageHeader
            title="Budgets Expenses"
            breadcrumbs={[
              {
                label: <i className="ti ti-smart-home" />,
                path: all_routes.adminDashboard,
              },
              { label: "Accounting" },
              { label: "Budgets Expenses List", isActive: true },
            ]}
            // listViewPath={all_routes.clientlist}
            listViewPath="#"
            onExportCSV={canExport ? () => exportToCSV(ExportData, "budgets_expenses_data") : undefined}
            onExportExcel={canExport ? () => exportToExcel(ExportData, "budgets_expenses_data") : undefined}
            onExportPDF={canExport ? () => exportToPDF(ExportData, "budgets_expenses_data") : undefined}
            onAdd={canAdd ? () => showModal("create") : undefined}
            addLabel="Add Budget Expenses"
            exportEnabled={canExport}
            addButtonEnabled={canAdd}
            rightExtra={<CollapseHeader />}
          />
          {/* /Breadcrumb */}
          {/* Budgets list */}
          <div className="card">
            <StatusFilterHeader
              title="Budgets Expenses List"
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              selectedSort={selectedSort}
              setSelectedSort={setSelectedSort}
            />
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filtereddata}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Budgets list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025 © hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      <BudgetExpensesModal
        modalType={modalType}
        handleCancel={handleCancel}
        isModalVisible={isModalVisible}
        selectedRowData={selectedRowData}
        setTableKey={setTableKey}
      />
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.budget_expense_id &&
          handleDeleteBudget(selectedRowData.budget_expense_id)
        }
      />
    </>
  );
};

export default BudgetExpenses;
